import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanDeactivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { lastValueFrom, map, Observable, of } from 'rxjs';
import { PermissionService } from '../permission.service';
import { RouteMasterService } from '../route-master.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {

  constructor(private authService: AuthService, private permissionService: PermissionService,
    private router: Router, private _snackBar: MatSnackBar, private _routes: RouteMasterService,
    private snackBar: MatSnackBar) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    let isAuthenticated = this.authService.getAuthStatus();

    if (isAuthenticated) {
      let goingToUrl = state.url;

      let allowed_routes = [];
      if (this.authService.getUserProfile().role == 'customer') {
        allowed_routes = this._routes.always_allow_routes.external;
      } else {
        allowed_routes = this._routes.always_allow_routes.internal;
      }

      // if (allowed_routes.indexOf(goingToUrl) > -1) {
      //   return true;
      // }

      for (let allowed_idx = 0; allowed_idx < allowed_routes.length; allowed_idx++) {
        if (allowed_routes[allowed_idx] == goingToUrl.substring(0, allowed_routes[allowed_idx].length)) {
          return true
        }
      }

      let url_db_value = this._routes.getDBValueByUrl(goingToUrl); // set service import for s (routemaster service)


      // if (url_db_value == null) {
      //   console.error(`Entry  for url "${goingToUrl}" for route does not exist in file 'src/app/route-master.service.ts'`);
      //   return false;
      // }
      let hasViewPermissionObs = this.permissionService.getPagePermissions(url_db_value).pipe(
        map(response => {
          if (!response.view_permission) {
            // snack bar when status code= 400
            this.snackBarOnError("Access Forbidden! Please contact admin to continue");
            this.authService.redirectToUrl = state.url;
          }
          return response.view_permission
        })
      );
      return hasViewPermissionObs;

    }
    else {
      this.router.navigate(['authentication/login']);
      this.authService.redirectToUrl = state.url;
    }


  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isAuthenticated = this.authService.getAuthStatus();

    if (!isAuthenticated) {
      this.router.navigate(['authentication/login']);
    }
    return isAuthenticated;
  }

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }


  snackBarOnError(snack: string) {
    this.snackBar.open(snack, 'Close', {
      verticalPosition: 'top',
      duration: 2000,
    });
  }
}
